import RequestNewPasswordForm from "../components/form/RequestNewPasswordForm";
import HeaderLogo from "../components/shared/HeaderLogo";
import { Box } from "@mui/system";

const RequestNewPasswordPage = () => {
  const requestNewPasswordPageStyle = {
    display: "flex",
    justifyContent: 'center',
    height: "100vh"
};

const requestNewPasswordContainerStyle = {
    justifySelf: "center",
    display: "grid",
    gridAutoRows: "1fr 2fr"
}

const headerLogoStyle = {
    maxHeight: "150px",
    minWidth: "350px",
    alignItems: "end"
};

  return (
    <Box sx={requestNewPasswordPageStyle}>
            <div style={requestNewPasswordContainerStyle}>
                <HeaderLogo {...headerLogoStyle}/>
                <div style={{margin: "1em auto 0"}}>
                  <RequestNewPasswordForm/>
                </div>
            </div>
        </Box>
  )
}

export default RequestNewPasswordPage;